<template>
  <div class="home_center">
    <home-header
      :isShow="true"
      ref="child"
      @func="getSearchKeyword"
      activeIndex="3"
    ></home-header>

    <!-- 活动banner -->
    <div class="banner-wrap">
      <el-carousel trigger="click" height="420px">
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <el-image
            @click="bannernavTo(item)"
            class="banner-warp"
            :src="item.img"
            fit="contain"
          ></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>

    <index-nrca :activity_nrca="activity_nrca"></index-nrca>

    <!-- <hold-activity></hold-activity> -->
      <organize-events></organize-events>

    <!--  -->
    <div class='tab-wrap' >
      <div class="tab-pane" @click="navToAwardWork" >
        <i class="icon"
          ><svg
            t="1629161155898"
            class="icon"
            viewBox="0 0 1185 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="8987"
            width="64"
            height="64"
          >
            <path
              d="M564.951579 988.698947a285.345684 285.345684 0 1 1 285.345684-285.345684A286.369684 286.369684 0 0 1 564.951579 988.698947z m0-507.957894a222.612211 222.612211 0 1 0 222.61221 222.61221 223.474526 223.474526 0 0 0-222.61221-222.61221z"
              fill="#FFB463"
              p-id="8988"
            ></path>
            <path
              d="M655.872 490.145684h-241.448421L232.582737 110.753684h241.448421z m-197.551158-62.706526h100.325053l-122.287158-253.978947h-100.298105z"
              fill="#FFB463"
              p-id="8989"
            ></path>
            <path
              d="M687.211789 490.145684h-191.326315a31.366737 31.366737 0 1 1 0-62.706526h150.501052l122.287158-253.978947h-100.271158l-81.515789 172.463157a30.881684 30.881684 0 0 1-56.42779-25.088l100.325053-206.955789h241.448421z"
              fill="#FFB463"
              p-id="8990"
            ></path>
            <path
              d="M564.951579 838.224842a137.970526 137.970526 0 1 1 137.970526-137.970526 135.248842 135.248842 0 0 1-137.970526 137.970526z m0-213.207579a75.264 75.264 0 1 0 75.264 75.264 76.288 76.288 0 0 0-75.264-75.290947z"
              fill="#FFB463"
              p-id="8991"
            ></path></svg
          ></i>
        <div class='name'>获奖作品</div>
      </div>

      <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">
        <el-tab-pane label="本馆活动" name="first">
          <!-- 活动列表开始 -->
          <div v-if="dataEmptyOwn">
            <index-list :list-val="listDataOwn"></index-list>
            <pagination :listNum="listNumOwn" :getList="getList"></pagination>
          </div>
          <data-empty v-else></data-empty>
        </el-tab-pane>

        <el-tab-pane label="全部活动" name="second">
          <div class="hdnum">
            <label></label>
            「共{{ listNum }}场活动」
            <!-- <el-input class="search" :value="keywords" v-model="keywords" placeholder="请输入活动名称 机构名称(主办方 参赛机构)"></el-input>
            <el-button icon="el-icon-search" type="primary"  @click="SearchActivity"></el-button> -->
          </div>
          <div class="hdlabel">
            <!-- <div class="lx">
             <el-link disabled :underline="false">类型：</el-link>
             <el-link v-for="(v, index) in searchData.tips" :key="index" :underline="false" v-if="v.code==type" type="success">{{v.name}}</el-link>
             <el-link :underline="false" v-else @click="getType(v.code)">{{v.name}}</el-link>
           </div> -->
            <div class="lx sf">
              <el-link disabled :underline="false">类型：</el-link>
              <div class="sfBox">
                <el-link
                  v-for="(v, index) in searchData.tips"
                  :key="index"
                  :underline="false"
                  v-if="v.code == type"
                  type="primary"
                >{{ v.name }}</el-link
                >
                <el-link :underline="false" v-else @click="getType(v.code)">{{
                    v.name
                  }}</el-link>
              </div>
            </div>
            <div class="lx">
              <el-link disabled :underline="false">状态：</el-link>
              <el-link
                v-for="(v, index) in searchData.status"
                :key="index"
                :underline="false"
                v-if="v.code == status"
                type="primary"
              >{{ v.name }}</el-link
              >
              <el-link v-else @click="getStatus(v.code)" :underline="false">{{
                  v.name
                }}</el-link>
            </div>
            <div class="sf">
              <el-link class="sfLabel" disabled :underline="false"
              >省份：</el-link
              >
              <div class="sfBox">
                <el-link
                  v-for="(v, index) in searchData.province"
                  :key="index"
                  :underline="false"
                  v-if="v.code == province"
                  type="primary"
                >{{ v.name }}</el-link
                >
                <el-link v-else @click="getProvince(v.code)" :underline="false">{{
                    v.name
                  }}</el-link>
              </div>
            </div>
          </div>

          <!-- 活动列表开始 -->
          <div v-if="dataEmpty">
            <index-list :list-val="listData"></index-list>
            <Pagination :listNum="listNum" :getList="getList"></Pagination>
          </div>
          <data-empty v-else></data-empty>
        </el-tab-pane>

      </el-tabs>
    </div>


    <div class="title-wrap">
      <title-bar
        :showmore="false"
        subtitle="Active Organizer"
        title="活跃参与机构"
      ></title-bar>
    </div>
    <!-- 活跃举办方开始 type 1 /activity/activity/join-ogran 活跃机构 -->
    <organ-index type="0"></organ-index>

    <home-footer></home-footer>
  </div>
</template>
<script>
// import HomeHeader from "@/components/Header";
import HomeHeader from "@/components/homeHeader";
import titleBar from "../pages/home/components/titleBar.vue";

import HomeFooter from "@/components/Footer";
import IndexList from "../index/components/Lists";
import Pagination from "@/components/Pagination";
import DataEmpty from "@/components/Data";
import IndexNrca from "../index/components/Nrca";
import HoldActivity from "../index/components/holdActivity.vue";
import OrganIndex from "../pages/home/components/activeOriganizer.vue";

import organizeEvents from '../components/organizeEvents.vue'

export default {
  name: "SearchActivity",
  components: {
    HomeHeader,
    HomeFooter,
    IndexList,
    Pagination,
    DataEmpty,
    IndexNrca,
    HoldActivity,
    OrganIndex,
    titleBar,
    organizeEvents
  },
  data() {
    return {
      // banH:650,
      page: 1,
      page_size: 9,
      pageOwn: 1,
      page_sizeOwn: 12,
      type: "",
      status: "",
      province: "",
      keywords: "",
      listNum: 0,
      listNumOwn: 0,
      activity_nrca: {},
      searchData: {},
      listData: {},
      listDataOwn: {},
      bannerList: [],
      dataEmpty: true,
      dataEmptyOwn: true,
      activeName: "second",
      group: "pc",
      tips: ""
    };
  },
  created() {
    this.getUrl();
    this.getOgranId();
    this.getSearchKeyword();
  },
  methods: {
    navToAwardWork(){
      console.error('work', this.activeName);
      const rules = {
        'first':0,
        'second':1,
      }
      // return;
      this.$router.push({
        path: '/awardWorks',
        query:{ activeIndex: rules[this.activeName]}
      })
    },
    // banner跳转
    bannernavTo(item) {
      window.open(item.url, "_target");
    },
    getUrl() {
      let url = this.$route.query.redirect;
      console.log(url);
      this.$router.push({
        path: url
      });
    },
    getOgranId() {
      let ogran_id = this.$route.params.id;
      ogran_id = localStorage.getItem("ogran_id");
      if (ogran_id) {
        localStorage.setItem("ogran_id", ogran_id);
        this.$data.activeName = "first";
      }
    },
    getSearchKeyword(data) {
      var keyword = this.$route.params.keyword;
      if (keyword != "undefined") {
        this.keywords = keyword;
        this.activeName = "second";
      }
      // this.activeName = 'fir'
      this.SearchActivity();
      console.log(keyword, data, this.keywords, "携带参数");
    },
    getType(type) {
      this.$data.type = type;
      this.tips = type;
      this.getList(this.$data.page, this.$data.page_size);
    },
    getStatus(status) {
      this.$data.status = status;
      this.getList(this.$data.page, this.$data.page_size);
    },
    getProvince(province) {
      this.$data.province = province;
      this.getList(this.$data.page, this.$data.page_size);
    },
    getSearch() {
      var data = {
        type: this.$data.type,
        status: this.$data.status,
        province: this.$data.province
      };
      this.$api
        .activitySearch(data)
        .then(res => {
          //数据处理
          this.$data.searchData = res.data;
        })
        .catch(err => console.log(err));
    },
    SearchActivity() {
      // if (this.keywords == "") {
      //   this.$message("请输入搜索关键词");
      //   return;
      // }
      this.getList(this.$data.page, this.$data.page_size);
    },
    getList(page, page_size) {
      if (this.activeName == "first") {
        var data = {
          group: this.group,
          page: page,
          page_size: page_size,
          organ_id: localStorage.getItem("ogran_id")
        };
        this.$api
          .activityOwn(data)
          .then(res => {
            //数据处理
            if (res.data.activity_list == "") {
              this.dataEmptyOwn = false;
            } else {
              this.dataEmptyOwn = true;
            }
            this.$data.activity_nrca = res.data.activity_nrca;
            this.$data.listDataOwn = res.data.activity_list;
            this.$data.listNumOwn = res.data.activity_num;
          })
          .catch(err => console.log(err));
      } else {
        var data = {
          keywords: this.$data.keywords,
          status: this.$data.status,
          // type: this.$data.type,
          tips: this.tips,
          province: this.$data.province,
          page: page,
          page_size: page_size
        };
        this.$api
          .activityList(data)
          .then(res => {
            //数据处理
            if (res.data.activity_list == "") {
              this.dataEmpty = false;
            } else {
              this.dataEmpty = true;
            }
            this.$data.activity_nrca = res.data.activity_nrca;
            this.$data.listData = res.data.activity_list;
            this.$data.listNum = res.data.activity_num;
            this.keywords = "";
          })
          .catch(err => console.log(err));
      }
    },
    getBanner() {
      let ogran_id = localStorage.getItem('ogran_id');
      this.$api
        .bannerList({
          ogran_id: ogran_id,
          position:1
        })
        .then(res => {
          //数据处理
          this.$data.bannerList = res.data;
        })
        .catch(err => console.log(err));
    },

    getOwnActivity(page, page_size) {},
    handleClick(activeName) {
      this.$refs["child"].setInputValue();
      console.log("handleclick", activeName);
      if (activeName == "first") {
        this.getList(this.$data.pageOwn, this.$data.page_sizeOwn);
      } else {
        this.keywords = "";
        this.type = "";
        this.status = "";
        this.province = "";
        this.getList(this.$data.page, this.$data.page_size);
      }
    }
  },

  mounted: function() {
    this.getSearch();
    this.getList(this.$data.page, this.$data.page_size);
    this.getBanner();
  }
};
</script>
<style scoped>
.home_center {
  height: auto;
  background: #eaeaea;
}
/* banner部分 */
.el-carousel__container {
  height: 650px !important;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.search {
  width: 350px;
  margin-right: 20px;
}
/* 活动数量标题 */
.hdnum {
  width: 1200px;
  margin: 30px auto;
  display: flex;
  align-items: center;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #3370ff;
}
.hdnum label {
  display: inline-table;
  width: 10px;
  height: 21px;
  background: #ffb463;
  border-radius: 5px;
  margin-right: 20px;
}
.hdlabel {
  width: 1201px;
  background: #ffffff;
  border-radius: 10px;
  margin: 0 auto 20px auto;
  display: flex;
  padding: 0px 10px 20px 10px;
  box-sizing: border-box;
  flex-direction: column;
}
.lx {
  padding-bottom: 20px;
  border-bottom: 1px dotted #eaeaea;
}
.hdlabel div {
  height: auto;
}
.hdlabel .lx > .el-link {
  margin-right: 20px;
  margin-bottom: 20px;
  margin-top: 20px;
}
.hdlabel .sf .el-link {
  margin-right: 20px;
  margin-top: 20px;
}
.el-tabs {
  width: 1200px;
  margin: 40px auto 0px auto;
}

.sfBox {
  display: inline-block;
  width: 1100px;
}
.lx,
.sf {
  display: flex;
  align-items: flex-start;
}

.el-tabs >>> .el-tabs__item {
  width: 130px !important;
  height: 55px !important;
  font-size: 24px !important;
  font-family: Microsoft YaHei !important;
  font-weight: bold !important;
  color: #999;
  margin: 0 auto !important;
}

.el-tabs >>> .is-active {
  color: #333 !important;
}
.el-tabs >>> .el-tabs__active-bar {
  display: block;
  width: 90px !important;
  height: 4px !important;
  background: #3370ff;
  border-radius: 2px;
  margin: 10px auto 0px auto !important;
}
.el-tabs >>> .el-tabs__header {
  margin: 0px;
}
/* .el-tabs >>> .el-link{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 26px;
  } */

/* banner */
.banner-wrap {
  width: 1200px;
  /* height: 420px; */
  margin: 40px auto;
  border-radius: 10px;
  overflow: hidden;
}
.banner-wrap {
  width: 1200px;
  height: 420px;
}

.title-wrap {
  width: 1200px;
  margin: 0 auto;
  padding: 0 0 30px;
}

.tab-wrap{
  position: relative;
  width: 1200px;
  margin: 0 auto;
}
.tab-pane{

  position: absolute;
  left: 300px;
  top: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #3370ff;
  width: 140px;
  height: 35px;
  border-radius: 20px;
  color: #3370ff;
  cursor: pointer;
  z-index: 1000;
  
}
.name{
  font-size: 13px;
}
.tab-wrap .icon{
  width: 26px;
  height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/searchactivity/SearchActivity.vue